// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_6Y9","cls2":"common-cls2_4ji common-cls1_6Y9"};